import bookState from "@/store/modules/book/state";
import { formatBookCancelTerm } from "@/utils/date";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.locale("ko");
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default {
  entrance(state) {
    return state.serviceInfo.entrance ? state.serviceInfo.entrance : {};
  },

  driveDates(state) {
    if (!state.serviceInfo.driveDates) {
      return "";
    }
    if (bookState.withCalendarYn) {
      return `${state.serviceInfo.driveDates[0].date} ~ ${
        state.serviceInfo.driveDates[state.serviceInfo.driveDates.length - 1]
          .date
      }`;
    }
    return state.serviceInfo.driveDates
      .map((dateInfo, idx) => {
        return `${idx + 1}차 : ${dayjs(dateInfo.date).format(
          "YYYY-MM-DD(dd)"
        )}`;
      })
      .join("<br />");
  },

  bookHelpText(state) {
    if (state.serviceInfo.bookHelpText) {
      return state.serviceInfo.bookHelpText.split("\n");
    } else {
      return null;
    }
  },

  bookIntervals(state) {
    if (state.serviceInfo.bookIntervals) {
      return state.serviceInfo.bookIntervals;
    } else {
      return null;
    }
  },

  festaPeriod(state) {
    const driveDates = state.serviceInfo.driveDates;
    if (driveDates && driveDates.length > 0) {
      const firstDay = driveDates[0].date;
      const endDay = driveDates[driveDates.length - 1].date;
      if (driveDates.length > 1) {
        return `${dayjs(firstDay).format("YYYY.MM.DD")} - ${dayjs(
          endDay
        ).format("MM.DD")}`;
      } else {
        return `${dayjs(firstDay).format("YYYY.MM.DD")}`;
      }
    } else {
      return null;
    }
  },

  serviceCode(state) {
    if (state.serviceInfo.serviceCode) {
      return state.serviceInfo.serviceCode;
    } else {
      return null;
    }
  },

  serviceUid(state) {
    if (state.serviceInfo.uid) {
      return state.serviceInfo.uid;
    } else {
      return null;
    }
  },

  serviceName(state) {
    if (state.serviceInfo.name) {
      return state.serviceInfo.name;
    } else {
      return null;
    }
  },

  timeFares(state) {
    const timeFares = state.serviceInfo.timeFares;
    if (timeFares) {
      return timeFares.map((line) => {
        if (line.forwardBeginTimeText) {
          line.forwardBeginTimeText = line.forwardBeginTimeText.replace(
            /\n/gi,
            "<br />"
          );
        }
        if (line.backwardBeginTimeText) {
          line.backwardBeginTimeText = line.backwardBeginTimeText.replace(
            /\n/gi,
            "<br />"
          );
        }
        return line;
      });
    } else {
      return null;
    }
  },

  timeFareDisplayYn(state) {
    const timeFaresDisplayYn =
      state.serviceInfo?.contentProps?.pages?.timeFares?.displayYn;
    if (timeFaresDisplayYn === undefined) {
      return true;
    }
    return timeFaresDisplayYn;
  },

  joinHelpText(state) {
    const helpText =
      state.serviceInfo?.contentProps?.pages?.joins?.[0]?.joinText;
    if (helpText === undefined) {
      return null;
    }
    return helpText.split("\n");
  },

  entranceText(state) {
    if (
      state.serviceInfo?.contentProps?.pages?.entrance?.entranceText ===
      undefined
    ) {
      return null;
    }
    return state.serviceInfo?.contentProps?.pages?.entrance?.entranceText;
  },

  // 사전 예약 기간
  preBookTermText(state) {
    const preBookInterval = state.serviceInfo.bookIntervals?.find(
      (bookInterval) => bookInterval.bookPointCode === "BKP-PRE"
    );
    if (!preBookInterval) {
      return;
    }
    const { bookBeginDtmText, bookEndDtmText, bookPointName } = preBookInterval;
    return `<span>${bookPointName} 기간은 <strong>${bookBeginDtmText} ~ ${bookEndDtmText}</strong>까지 입니다.</span>`;
  },

  // 사전 예약 취소 기간
  preBookCancelTermText(state) {
    const preBookInterval = state.serviceInfo.bookIntervals?.find(
      (bookInterval) => bookInterval.bookPointCode === "BKP-PRE"
    );
    if (!preBookInterval) {
      return;
    }
    const { bookCancelDtm, bookPointName } = preBookInterval;
    return `<span>${bookPointName} 취소 기한은 <strong>${formatBookCancelTerm(
      bookCancelDtm
    )}</strong>까지 입니다.</span>`;
  },

  // 잔여 예약 기간
  remainBookTermText(state) {
    const remainBookInterval = state.serviceInfo.bookIntervals?.find(
      (bookInterval) => bookInterval.bookPointCode === "BKP-POST"
    );
    if (!remainBookInterval) {
      return;
    }
    const { bookBeginDtmText, bookEndDtmText } = remainBookInterval;
    return `<span>잔여 좌석 예약은 <strong>${bookBeginDtmText} ~ ${bookEndDtmText}</strong>까지 잔여석에 한해 예약 가능합니다.</span>`;
  },

  // 잔여 예약 취소 기간
  remainBookCancelTermText(state) {
    const remainBookInterval = state.serviceInfo.bookIntervals?.find(
      (bookInterval) => bookInterval.bookPointCode === "BKP-POST"
    );
    if (!remainBookInterval) {
      return;
    }
    const { bookBeginDtm, bookCancelDtm, bookPointName } = remainBookInterval;
    if (!bookCancelDtm || bookBeginDtm > bookCancelDtm) {
      return `<strong class="emphasis">${bookPointName}은 예약취소가 불가합니다.</strong>`;
    }
    return `<span>${bookPointName} 취소 기한은 <strong>${formatBookCancelTerm(
      bookCancelDtm
    )}</strong>까지 입니다.</span>`;
  },

  // 승차 위치 표시 유무 - 고정노선
  isShowOnStationLocationOfFixedLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.fixedLine?.onStationLocationYn ??
      true
    );
  },

  // 승차 위치 표시 유무 - 기타노선
  isShowOnStationLocationOfEtcLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.etcLine?.onStationLocationYn ??
      true
    );
  },

  // 하차 위치 표시 유무 - 고정노선
  isShowOffStationLocationOfFixedLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.fixedLine?.offStationLocationYn ??
      true
    );
  },

  // 하차 위치 표시 유무 - 기타노선
  isShowOffStationLocationOfEtcLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.etcLine?.offStationLocationYn ??
      true
    );
  },

  // 승차 시간 표시 유무 - 고정노선
  isShowOnStationTimeOfFixedLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.fixedLine?.onStationTimeYn ?? true
    );
  },

  // 승차 시간 표시 유무 - 기타노선
  isShowOnStationTimeOfEtcLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.etcLine?.onStationTimeYn ?? true
    );
  },

  // 하차 시간 표시 유무 - 고정노선
  isShowOffnStationTimeOfFixedLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.fixedLine?.offStationTimeYn ??
      false
    );
  },

  // 하차 시간 표시 유무 - 기타노선
  isShowOffStationTimeOfEtcLine(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.etcLine?.offStationTimeYn ?? false
    );
  },

  getTwcConfig(state) {
    return state.serviceInfo?.contentProps?.extensions?.twc;
  },

  getGitpleConfig(state) {
    return state.serviceInfo?.contentProps?.extensions?.gitple;
  },

  joinFirst(state) {
    return (
      state.serviceInfo?.contentProps?.pages?.joins?.[0]?.joinFirst || false
    );
  },

  // 현재 시각이 속한 예약 구간의 bookIntervalCode (없으면 null)
  currentBookIntervalCode(state) {
    const intervals = state.serviceInfo.bookIntervals;
    if (!intervals?.length) {
      return null;
    }
    const now = dayjs();
    const current = intervals.find(
      (it) =>
        now.isSameOrAfter(dayjs(it.bookBeginDtm)) &&
        now.isSameOrBefore(dayjs(it.bookEndDtm))
    );
    return current?.bookIntervalCode ?? null;
  },

  // 노선유형별 최대 예약가능한 횟수
  maxBookCount(state) {
    return state.serviceInfo.maxBookCount;
  },
};
